import comp from "./AssessmentGradeScaleToolView";
export default comp;
